import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import { StoreState } from '../../../reducers';
import { StyledDriveItemInfoButton } from './styles';
import { createNotification } from '../../NotificationBar/actions';
import RoutesUtils from '../../../utils/routes';
import { RoutePath } from '../../../routes/constants';
import { RouterParamsState } from '../../SetRouteParams/reducer';
import { DriveItemListOrigin } from '../../DriveItemListPage/constants';
import { GalleryInfosState } from '../../Gallery/reducer';

export interface DriveItemInfoButtonProps {
	driveItem: Api.DriveItem;
	dispatch: Dispatch<StoreState>;
	routerParamsHistory: RouterParamsState[];
	galleryInfos: GalleryInfosState;
}

const DriveItemInfoButton = (props: DriveItemInfoButtonProps) => {

	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		e.stopPropagation();
		const { driveItem, dispatch, routerParamsHistory, galleryInfos } = props;

		if (driveItem.endDate && Utils.parseDate(driveItem.endDate) < new Date()) {
			dispatch(createNotification('error.content_expired', { id: driveItem.id }));
			return;
		}

		const currentRoute = routerParamsHistory[routerParamsHistory.length - 1];
		const { routes, params } = currentRoute;
		const isCurrentPageDriveItemList = RoutesUtils.doesRoutesContainsPath(RoutePath.DriveItemListPage, routes);
		const isCurrentPageTheater = RoutesUtils.doesRoutesContainsPath(RoutePath.TheaterList, routes) || RoutesUtils.doesRoutesContainsPath(RoutePath.Theater, routes);
		const { origin, originParam } = params;
		let folderId;
		if ((isCurrentPageDriveItemList || isCurrentPageTheater) && origin === DriveItemListOrigin.Folder) {
			folderId = originParam ? parseInt(originParam, 10) : galleryInfos.config.applicationGallery;
		}
		window.location.hash = `#${ RoutesUtils.getPathDriveItemDetailPage(driveItem.id, folderId) }`;
	};

	return (
		<StyledDriveItemInfoButton onClick={handleClick}>
			{Utils.getSvgIcon('iconset_details-bold')}
		</StyledDriveItemInfoButton>
	);
};

const mapStateToProps = (state: StoreState) => {
	const { routerParamsHistory, galleryInfos } = state;
	return { routerParamsHistory, galleryInfos };
};

export default connect(mapStateToProps)(DriveItemInfoButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItem/InfoButton/index.tsx